import { IScheduleFrequency } from './ISchedule';

export interface IEditableServerSettings {
  activeDirectorySyncScheduleFrequency?: IScheduleFrequency;
  defaultLanguage?: string;
  defaultLocale?: string;
  defaultStartPage?: string;
  embeddedCredentialsEnabled?: boolean;
  guestEnabled?: boolean;
  recommendationsTrainerScheduleFrequency?: IScheduleFrequency;
  refreshTokenEnabled?: boolean;
  scheduledActiveDirectorySyncEnabled?: boolean;
  schedulingEnabled?: boolean;
  savedAccessTokensEnabled?: boolean;
  savedPasswordsEnabled?: boolean;
  personalSandboxEnabled?: boolean;
  personalSandboxByDefaultEnabled?: boolean;
  signInNoteText?: string;
  signInNoteUrl?: string;
  runNowEnabled?: boolean;
}

export let defaultExtensionsServerSettings: IExtensionsServerSettings = {
  extensionsGloballyEnabled: true,
  blocklist: []
};

export interface IExtensionsServerSettings {
  extensionsGloballyEnabled: boolean;
  blocklist: string[];
}

export let defaultExtsvcServerSettings: IExtsvcServerSettings = {
  enabled: false,
};

export interface IExtsvcServerSettings {
  enabled: boolean;
}


